import React from 'react';
import { ClaimReview } from './pages/ClaimReview';
export function App() {
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-0">
      <ClaimReview data-id="element-1" />
    </div>;
}